window.onload = function() {

  let filter_value = localStorage.getItem("filter_value");

  //  check wether the filter exists in the url, then pre-select it.
  if(window.location.href.indexOf(filter_value) !== -1) {
      document.getElementById(`filter-${filter_value.replace(" ", "&")}`).classList.add('active--filters');
  } 

};

let divs = document.querySelectorAll('.filter-collection-box');

async function triggerFilter(elem, collectionHandle, filterValue) {

  // if the clicked element already has the 'active' class, then remove the class.
  if(elem.classList.contains('active--filters')) {
      // remove the active class to all filters
        divs.forEach(el => {
          el.classList.remove("active--filters");
        });

        newUrl = `/collections/${collectionHandle}`;

        window.history.replaceState(null, null, newUrl);

        let response = await fetch(newUrl);
        if (response.ok) { // if HTTP-status is 200-299
          // get the response body (the method explained below)
          let html = await response.text();
          let parser = new DOMParser();
          let doc = parser.parseFromString(html, "text/html")
          let elem = document.querySelector('.collection');
          elem.parentNode.removeChild(elem);
          
          let refElem =  document.querySelector('.filter-bar').nextSibling;
          let parent = refElem.parentNode;

          let newEl = document.createElement('div');
          newEl.className = "collection"; 
          newEl.innerHTML = doc.getElementsByClassName("collection")[0].innerHTML

          // now we can call it the same way as insertBefore()
          parent.insertBefore(newEl, refElem);

        } else {
          console.error("HTTP-Error: " + response.status);
        }

        // remove the filter value from the localStorage
        localStorage.removeItem("filter_value");

        console.log(`Filter: ${filterValue} is no longer active!`);

  }
  // otherwise, just append the active class to the element...
    else {
        // remove the active class to all filters
        divs.forEach(el => {
            el.classList.remove("active--filters");
        });

      // then append the 'active' class to the element...
      elem.classList.add('active--filters');

        newUrl = `/collections/${collectionHandle}/${filterValue}`;

        window.history.replaceState(null, null, newUrl);

        let response = await fetch(newUrl);
        if (response.ok) { // if HTTP-status is 200-299
          // get the response body (the method explained below)
          let html = await response.text();
          let parser = new DOMParser();
          let doc = parser.parseFromString(html, "text/html")
          let elem = document.querySelector('.collection');
          elem.parentNode.removeChild(elem);
          
          let refElem =  document.querySelector('.filter-bar').nextSibling;
          let parent = refElem.parentNode;

          let newEl = document.createElement('div');
          newEl.className = "collection"; 
          newEl.innerHTML = doc.getElementsByClassName("collection")[0].innerHTML

          // now we can call it the same way as insertBefore()
          parent.insertBefore(newEl, refElem);

        } else {
          console.error("HTTP-Error: " + response.status);
        }

       // save the filter value to the localStorage
       localStorage.setItem("filter_value", filterValue);


      console.log(`Filter: ${filterValue} is active!`);

  }

}

$(window).on('load', function() {
  if ($(window).width() <= 700) {  
    slickslider();
    
  } 
});

function slickslider() {
    $(".filter-bar").slick({
      slidesToShow:  2,
      dots: true,
      mobileFirst: true,
      prevArrow: '<button class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill="#FFFFFF"></circle><path d="M21 12L13 18.5L21 25" stroke="#B6637B" stroke-width="3" stroke-linecap="round"></path></svg></button>',
      nextArrow: '<button class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill="#FFFFFF"></circle><path d="M21 12L13 18.5L21 25" stroke="#B6637B" stroke-width="3" stroke-linecap="round"></path></svg></button>',
      responsive: [
            {
                    breakpoint: 768,
                    settings: 'unslick',
                    slidesToShow: 2,
            }
      ]
    })

    $('.filter--bar__container').show();
  
} 